export const heatmap = {
    cell: {
        style: {
            shape: "rect",
            fillOpacity: 1
        }
    },
    cellBackground: {
        visible: !1
    },
    label: {
        style: {
            lineWidth: 2
        }
    }
};
//# sourceMappingURL=heatmap.js.map
